import { Link } from 'react-router-dom';
import { latestUpdates } from '@/mocks/zh/comics';

export default function LatestSection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="text-xs font-label text-primary-500 uppercase tracking-wider">追更必备</span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-2">
              最新<strong className="text-primary-500">更新</strong>
            </h2>
            <p className="text-sm text-foreground-600 mt-2 max-w-md">
              第一时间获取最新章节，不再错过任何精彩
            </p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-label whitespace-nowrap cursor-pointer transition-colors duration-200"
          >
            更多更新 <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {latestUpdates.map((comic) => (
            <Link
              key={comic.id}
              to="/category/all"
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  title={`${comic.title} - 韩漫免费网站`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute top-2 right-2">
                  <span className="bg-primary-500 text-background-50 text-[10px] px-2 py-0.5 rounded font-label whitespace-nowrap">
                    NEW
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-950/80 to-transparent p-3">
                  <p className="text-xs text-background-100/80">{comic.latestChapter}</p>
                </div>
              </div>
              <h3 className="text-sm font-heading font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 truncate">
                {comic.title}
              </h3>
              <div className="flex items-center gap-2 mt-1">
                <span className="text-xs text-foreground-500">{comic.author}</span>
                <span className="w-1 h-1 rounded-full bg-foreground-300" />
                <span className="text-xs text-accent-500">{comic.rating}</span>
              </div>
              <p className="text-[11px] text-foreground-400 mt-1">{comic.updateTime} 更新</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}